import actionTypes, * as actionGroups from "help-center/help-center-action-types"
import {
    resourceGetList,
    resourceGetDetail,
    resourcePostList,
} from "shared/djangio/action-creators"
import { segue, popPage, pushPage, } from "global-action-creators"

import urls from "imports/desktopPaths"

const MAX_POST_TO_DISPLAY = 1000

export const loadPosts = (filter = {}) =>
    (dispatch, getState) => {
        const searchTerm = getState().helpCenter.get('formValues').get('searchTerm')

        return dispatch(resourceGetList(
            DjangIO.app.blog.models.HelpCenterPost,
            actionGroups.getPosts,
            {
                limit: MAX_POST_TO_DISPLAY,
                advanced_search: searchTerm,
                ...filter
            },
            {},
            true
        ))
    }

export const loadDetailedPost = id =>
    dispatch =>
        dispatch(resourceGetDetail(
            DjangIO.app.blog.models.HelpCenterPost.objects.full_dehydrate('steps')
                .filter({
                    dehydrate_extra: ["related_posts"]
                }),
            actionGroups.getDetailedPost,
            id,
            {},
            // Caching has to be false. When getting a list of posts, steps is un-dehydrated that the resource_uri gets cached instead of full value
            // When navigating to detail view from a list of posts, the post should be fetched again with fully dehydrated steps
            false,
        )).catch(() =>
            dispatch(segue(urls.notFound))
        )

export const loadArticleGroup = id =>
    resourceGetDetail(
        DjangIO.app.blog.models.ArticleGroup.objects
            .full_dehydrate('article_group_members'),
        actionGroups.getArticleGroup,
        id,
        {},
        true,
    )

export const createPostView = kwargs =>
    resourcePostList(
        DjangIO.app.blog.models.PostView,
        actionGroups.createPostView,
        kwargs
    )

export const updateForm = (formKey, formValue) =>
    (dispatch) => {
        dispatch({
            type: actionTypes.UPDATE_FORM_VALUE,
            formKey,
            formValue
        })
    }

export const segueToHelpCenterHome = () =>
    (dispatch) => {
        dispatch(segue("/help/"))
    }

export const segueBackOnePage = (url) =>
    (dispatch) => {
        dispatch(popPage(url))
    }

export const segueToLink = url =>
    (dispatch) => {
        dispatch(pushPage(url))
    }

export const loadFeatures = () =>
    (dispatch, getState) => {
        const searchTerm = getState().helpCenter.get('formValues').get('searchTerm')

        return dispatch(resourceGetList(
            DjangIO.app.blog.models.FeatureType,
            actionGroups.getFeatures,
            {
                limit: MAX_POST_TO_DISPLAY,
                advanced_search: searchTerm,
            },
            {},
            true
        ))
    }

export const loadFeature = featureType =>
    dispatch =>
        dispatch(resourceGetList(
            DjangIO.app.blog.models.FeatureType,
            actionGroups.getFeature,
            {
                "short_code": featureType,
            },
            {},
            true
        )).then(response => dispatch(resourceGetList(
            DjangIO.app.blog.models.ArticleGroup.objects.filter({ dehydrate_extra: ["post_viewed"] }).full_dehydrate('article_group_members'),
            actionGroups.getArticleGroups,
            {
                feature: response.objects[0].id
            },
            {},
            true
        )))

export const loadPostsByFeature = featureId =>
    (dispatch, getState) => {
        const searchTerm = getState().helpCenter.get('formValues').get('featureSearchTerm')

        return dispatch(resourceGetList(
            DjangIO.app.blog.models.HelpCenterPost,
            actionGroups.getFeaturePosts,
            {
                limit: MAX_POST_TO_DISPLAY,
                advanced_search: searchTerm,
                article_group_members__article_group__feature_id: featureId
            },
            {},
            true
        ))
    }


export const clearFeatureSearch = () =>
    (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_FEATURE_SEARCH })
    }

export const loadModules = () =>
    (dispatch, getState) => {
        const searchTerm = getState().helpCenter.get('formValues').get('searchTerm')

        return dispatch(resourceGetList(
            DjangIO.app.blog.models.LearningModule.objects.filter({ dehydrate_extra: ["post_count", "post_viewed"] }),
            actionGroups.getModules,
            {
                limit: MAX_POST_TO_DISPLAY,
                advanced_search: searchTerm,
            },
            {},
            true
        ))
    }

export const loadModuleDetail = id =>
    dispatch =>
        dispatch(resourceGetDetail(
            DjangIO.app.blog.models.LearningModule.objects.filter({ dehydrate_extra: ["post_count", "post_viewed"] })
                .full_dehydrate("article_groups")
                .full_dehydrate("article_group")
                .full_dehydrate("article_group_members"),
            actionGroups.getModule,
            id,
        ))

export const loadModule = id =>
    dispatch =>
        dispatch(resourceGetDetail(
            DjangIO.app.blog.models.LearningModule.objects.filter({ dehydrate_extra: ["post_viewed"] }),
            actionGroups.getModule,
            id,
        )).then(response => (
            dispatch(resourceGetList(
                DjangIO.app.blog.models.ModuleStep.objects.full_dehydrate('post'),
                actionGroups.getModuleSteps,
                { learning_module: response.id },
                {},
                true
            ))
        ))

export const loadBestPractices = () =>
    (dispatch, getState) => {
        const searchTerm = getState().helpCenter.get('formValues').get('searchTerm')

        return dispatch(resourceGetList(
            DjangIO.app.blog.models.Post,
            actionGroups.getBestPractices,
            {
                limit: MAX_POST_TO_DISPLAY,
                advanced_search: searchTerm,
                blog_post_type: DjangIO.app.blog.types.BlogType.best_practices.value
            },
            {},
            true
        ))
    }

export const loadCaseStudies = () =>
    (dispatch, getState) => {
        const searchTerm = getState().helpCenter.get('formValues').get('searchTerm')

        return dispatch(resourceGetList(
            DjangIO.app.blog.models.Post,
            actionGroups.getCaseStudies,
            {
                limit: MAX_POST_TO_DISPLAY,
                advanced_search: searchTerm,
                blog_post_type: DjangIO.app.blog.types.BlogType.case_studies.value
            },
            {},
            true
        ))
    }

export const loadWhitePapers = () =>
    (dispatch, getState) => {
        const searchTerm = getState().helpCenter.get('formValues').get('searchTerm')

        return dispatch(resourceGetList(
            DjangIO.app.blog.models.Post,
            actionGroups.getWhitePapers,
            {
                limit: MAX_POST_TO_DISPLAY,
                advanced_search: searchTerm,
                blog_post_type: DjangIO.app.blog.types.BlogType.white_papers.value
            },
            {},
            true
        ))
    }
